<template>
  <page layoutClass="campaign-scheduler" :err="err">
    <b-row>
      <b-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3" class="py-4">
        <schedule-linkedin-card class="my-3" scheduleModalID="schedule-campaign-content">
          <template v-slot:schedule-posts-modal>
            <schedule-posts-modal
              :jobIDs="api && Array.isArray(api.jobConnections.edges) && contentType === 'jobs' ? api.jobConnections.edges.map(({ entry }) => entry.id) : undefined"
              :contentShareIDs="api && Array.isArray(api.contentShareConnections.edges) && contentType === 'content' ? api.contentShareConnections.edges.map(({ entry }) => entry.id) : undefined"
              :campaignID="campaignID"
              @modal-close="closePage()"
            />
          </template>
        </schedule-linkedin-card>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import ms from 'ms';
import enumsMixin from '@src/mixins/enums';
import CampaignScheduleQuery from '@src/graphql/queries/CampaignSchedule.gql';
import scheduleLinkedInMixin from '@src/mixins/scheduleLinkedIn';
import { mapRoot } from '@src/mixins/root';
import Page from '@/components/Page';

export default {
  props: {
    contentType: {
      type: String,
      default: 'content'
    },
    contentIDs: {
      type: String,
    },
  },
  components: {
    Page,
  },
  mixins: [
    enumsMixin,
    scheduleLinkedInMixin,
  ],
  data() {
    return {
      campaignID: this.$route && this.$route.query && this.$route.query.campID ? this.$route.query.campID : null,
      err: null,
    };
  },
  apollo: {
    api: {
      query: CampaignScheduleQuery,
      variables() {
        console.log({ contentIDs: this.contentIDs, contentType: this.contentType });
        // @TODO: fix temporary hack of fake ids
        return {
          jobsWhere: {
            id_in: this.contentIDs && this.contentType === 'jobs' ? this.contentIDs.split(',') : null,
          },
          contentSharesWhere: {
            id_in: this.contentIDs && this.contentType === 'content' ? this.contentIDs.split(',') : [ 'RzjnR', '6D4Q6', 'M3mo6', 'lZbYl' ],
          },
        };
      },
      update({ company, user }) {
        const { contentShareConnections } = company;
        const { jobConnections } = user;
        return { jobConnections, contentShareConnections };
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
  },
  async mounted() {

    if (this.$route.query && this.$route.query.callback) {
      try {
        switch (this.$route.query.callback) {
          case 'connectedLinkedInForScheduling': {
            const campID = localStorage.getItem('campID');
            const compID = localStorage.getItem('compID');
            console.log('Local Storage Get', { campID, compID });
            if (campID) {
              sessionStorage.setItem('campID', campID);
              localStorage.removeItem('campID');
              this.campaignID = campID;
            }
            if (compID) {
              sessionStorage.setItem('compID', compID);
              localStorage.removeItem('compID');
            }
            await this.connectedLinkedInForScheduling();
            this.$bvModal.show('schedule-campaign-content');
            break;
          }
        }
      } catch (err) {
        this.$log.error(err);
      }
    }

    if (this.$route.query && this.$route.query.campID && this.$route.query.compID) {
      try {
        localStorage.setItem('campID', this.$route.query.campID);
        localStorage.setItem('compID', this.$route.query.compID);
        console.log('Local Storage Set', { campID: this.$route.query.campID, compID: this.$route.query.compID });
        sessionStorage.setItem('campID', this.$route.query.campID);
        sessionStorage.setItem('compID', this.$route.query.compID);
        await this.$root.captureLog({
          eventName: 'SCHEDULE_PAGE_VISITED',
          user: { self: true },
          campaignComponent: { id: this.$route.query.compID },
          campaign: { id: this.$route.query.campID },
        });
        this.$router.replace({ query: {} });
      } catch (err) {
        this.$log.error(err);
      }
    }
  },
  computed: {
    ...mapRoot([ 'user', 'company', 'isLoggedIn', 'isRecruiter', 'isRecruiterAdmin' ]),
    canScheduleLinkedInPosts() {
      const { sitePreferences, preferences } = this.company || {};
      const { canScheduleLinkedInPosts } = { ...sitePreferences, ...preferences };
      return canScheduleLinkedInPosts === true;
    },
  },
  methods: {
    closePage() {
      console.log('Close Page');
      this.$router.push('/');
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/User/CampaignScheduler.vue